module.exports = __webpack_public_path__ + "media/images/who-we-are-mobile-c64eed130024fbf88dfd04670b0dc4a3.jpg";